import type { IMessageFlash } from '#/global/helper/MessageFlash'

export const openBranchChange = () => {
    const div = document.createElement('div')
    div.dataset.dekGroup = 'header'
    div.dataset.dekControl = 'com-pobocka'
    div.dataset.dekTasks = 'scroll-top,open-tab'
    window.tasksRunner(0, div)
    window.tasksRunner(1, div)
}

export const addMessage = (event: CustomEvent<IMessageFlash>) => {
    window.vueMessagesStore.addMessage(event.detail)
}

export const redrawSnippets = () => {
    // @ts-expect-error Jquery
    // eslint-disable-next-line ts/no-unsafe-call, ts/no-unsafe-member-access
    void jQuery.nette.ajax({ url: location.href, noSpinner: true })
}
